import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Admin, useLogin, useNotify } from "react-admin";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/MyContext";

const Adminsignin = ({ onClose }: { onClose(): void }) => {
  const [email, setEmail] = useState("support@applaunchai.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { adminLogin } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const handleAdminLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    await adminLogin(email, password, setError, setLoading);

    // Success!
    onClose();
    navigate("/admin");
  };
  return (
    <DialogContent className="sm:max-w-[425px]">
    <DialogHeader>
      <DialogTitle>Admin Login</DialogTitle>
    </DialogHeader>
    <form
      onSubmit={handleAdminLogin}
      className="space-y-4 pt-2"
    >
      <div className="space-y-2">
        <Label htmlFor="admin-email">Email</Label>
        <Input
          id="admin-email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="admin-password">Password</Label>
        <Input
          id="admin-password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
      </div>
      <Button
        type="submit"
        className="w-full"
        disabled={loading}
      >
        {loading ? "Logging in..." : "Login as Admin"}
      </Button>
    </form>
  </DialogContent>
  )
}

export default Adminsignin